var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCorsair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 33.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.796 26.189)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-110.796 -26.189)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.977 9.912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2,35.855v-.036a6.492,6.492,0,0,1,6.616-6.634,6.686,6.686,0,0,1,5.021,2L87.394,32.85A5.1,5.1,0,0,0,83.8,31.256a4.317,4.317,0,0,0-4.234,4.526v.037A4.322,4.322,0,0,0,83.8,40.364a5.011,5.011,0,0,0,3.683-1.649l1.447,1.466a6.619,6.619,0,0,1-5.2,2.273A6.452,6.452,0,0,1,77.2,35.855Z",
    transform: "translate(-77.204 -29.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.941,35.855v-.036a6.708,6.708,0,0,1,13.415-.037v.037a6.708,6.708,0,0,1-13.415.036Zm11.051,0v-.036a4.395,4.395,0,0,0-4.361-4.563,4.335,4.335,0,0,0-4.325,4.526v.037a4.38,4.38,0,0,0,4.363,4.544A4.319,4.319,0,0,0,112.992,35.855Z",
    transform: "translate(-86.312 -29.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4,29.533h5.718a5.171,5.171,0,0,1,3.7,1.283,3.879,3.879,0,0,1,1.062,2.767v.037a3.851,3.851,0,0,1-3.041,3.885l3.463,4.857h-2.676l-3.152-4.472H133.66v4.472H131.4Zm5.553,6.36c1.612,0,2.639-.843,2.639-2.145v-.037c0-1.374-.989-2.126-2.657-2.126h-3.28v4.308Z",
    transform: "translate(-97.161 -29.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.924,40.385l1.356-1.613a5.939,5.939,0,0,0,4.05,1.668c1.392,0,2.272-.66,2.272-1.613v-.037c0-.916-.513-1.411-2.9-1.96-2.731-.66-4.27-1.466-4.27-3.831v-.037c0-2.2,1.832-3.72,4.38-3.72a7.111,7.111,0,0,1,4.655,1.612l-1.21,1.7a5.826,5.826,0,0,0-3.481-1.32c-1.32,0-2.09.679-2.09,1.521V32.8c0,.99.587,1.43,3.061,2.016,2.712.66,4.1,1.631,4.1,3.757v.037c0,2.4-1.888,3.831-4.581,3.831A7.9,7.9,0,0,1,154.924,40.385Z",
    transform: "translate(-105.821 -29.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.232,29.388h2.089l5.644,12.92h-2.382l-1.3-3.1h-6.066l-1.319,3.1h-2.309Zm3.225,7.825-2.218-5.131-2.2,5.131Z",
    transform: "translate(-113.798 -29.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.356,29.533h2.254V42.362h-2.254Z",
    transform: "translate(-124.39 -29.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.26,29.533h5.718a5.169,5.169,0,0,1,3.7,1.283,3.879,3.879,0,0,1,1.063,2.767v.037A3.851,3.851,0,0,1,225.7,37.5l3.464,4.857h-2.676l-3.152-4.472h-2.822v4.472H218.26Zm5.553,6.36c1.613,0,2.64-.843,2.64-2.145v-.037c0-1.374-.99-2.126-2.657-2.126h-3.281v4.308Z",
    transform: "translate(-129.142 -29.313)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.469,13.5S46.2,19.039,45.7,21.349c0,0,7.121,2.3,7.913,6.1C53.609,27.45,57.508,22.318,43.469,13.5Z",
    transform: "translate(-24.806 -13.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.408,24.853a24.448,24.448,0,0,1,1.419,4.66l-4.06-1.542c.376-2.464-2.022-6.215-2.022-6.215Z",
    transform: "translate(-20.489 -16.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.178,31.3a29.042,29.042,0,0,1,1.231,3.951l-3.661-.911C23.124,31.881,20.8,28.9,20.8,28.9Z",
    transform: "translate(-16.46 -19.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.62,23.325s16.327,11.466,17.4,15.915c.81,3.346-1.55,6.437-1.55,6.437s-1.258-8.736-32.546,4.53a16.82,16.82,0,0,0,4.436-12.913,16.491,16.491,0,0,0-1.536-5.612l7.332,3.887c.012.116.018.232.029.347a25.411,25.411,0,0,1-.612,8.552,20.228,20.228,0,0,0,.211-16.862l7.837,5.221c.032.26.05.522.075.785a25.31,25.31,0,0,1-.845,9.4,20.2,20.2,0,0,0-.236-19.692Z",
    transform: "translate(-13.929 -17.115)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCorsair);
export default __webpack_public_path__ + "static/media/logo_corsair.8201b065ac84692172c2f23fa1998a52.svg";
export { ForwardRef as ReactComponent };